import React from 'react';
import Notice from '../components/setting/Notice';

const NoticePage: React.FC = () => {
  return (
    <div className="main-container">
      <Notice mode="create" />
    </div>
  );
};

export default NoticePage;
